import styled from "styled-components";
import { ScanCow, ScanCrackerModal } from "../../assets/images";
import { useState } from "react";
import { CloseWhite } from "../../assets/icons";

const OTPModal = ({ onResend, onOTPComplete, email, phone, onClose }) => {
  const [otp, setOtp] = useState(new Array(4).fill(""));

  const handleChange = (element, index) => {
    let otpArray;
    if (element.value.length <= 1) {
      otpArray = [...otp.map((d, idx) => (idx === index ? element.value : d))];
      setOtp(otpArray);
    }
    if (isNaN(element.value)) return false;

    if (element.value !== "" && element.nextSibling) {
      element.nextSibling.focus();
    }
    if (element.value === "" && index > 0) {
      // Focus on the previous field
      element.previousSibling.focus();
    }
    if (otpArray?.filter((item) => item).length === 4) {
      onOTPComplete(Number(otpArray.join("")));
    }
  };

  return (
    <StyledOTPModal>
       <div style={{display:'flex',flexDirection:'column'}}>
       <ModalHeaderCow>
          <SpinWheelModalCow src={ScanCow} />
        </ModalHeaderCow>
        <ModalContent>
          <ModalHeaderContainer>
            <CloseButton onClick={onClose}>
              <CloseIcon src={CloseWhite} />
            </CloseButton>
          </ModalHeaderContainer>
          <ModalHeader>Enter your verification code</ModalHeader>
          <EnterOTPText>
            Enter the 4-digit code we have sent to your Mobile number {phone}
          </EnterOTPText>
          <VerifyOtpContainer>
            {otp.map((data, index) => {
              return (
                <VerifyOtpInput
                  type="password"
                  name="otp"
                  maxLength="2"
                  key={index}
                  value={data}
                  onChange={(e) => handleChange(e.target, index)}
                  onFocus={(e) => e.target.select()}
                  pattern="[0-9]*" inputmode="numeric"
                />
              );
            })}
          </VerifyOtpContainer>
          <DidNotReceive>Didn’t receive the code?</DidNotReceive>
          <ResendText onClick={onResend}>Re-send code</ResendText>
        </ModalContent>
      </div>
    </StyledOTPModal>
  );
};

const CloseIcon = styled.img`
  width: 1.5rem;
  height: 1.5rem;
`;

const CloseButton = styled.button`
  background: transparent;
  outline: none;
  border: none;
`;


const ModalHeaderCow = styled.div`
  display: flex;
  width: 100%;
  height:fit-content;
  object-fit:cover;
  background-image: url(${ScanCrackerModal});
  background-position:center center;
  justify-content: center;
  padding-top: 3rem;
`;

const StyledOTPModal = styled.div`
  height: 100vh;
  max-height: 100vh;
  position: absolute;
  width: 100%;
  top: 0;
  left: 0;
  > div {
    overflow: scroll;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.75);
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    z-index: 10;
  }
`;

const VerifyOtpInput = styled.input`
  border-radius: 0.5rem;
  background: #fcfdfe;
  border: 1px solid #eee;
  width: 2rem;
  height: 2.5rem;
  font-family: "Poppins";
  font-size: 2rem;
  text-align: center;
`;

const ModalContent = styled.div`
  height: fit-content;
  width: 85%;
  background: #1c1d21;
  border-radius: 0.5rem;
  padding: 1rem;
  text-align: center;
  gap: 0.5rem;
  display: flex;
  flex-direction: column;
  // justify-content: center;
  align-items: center;
`;

const VerifyOtpContainer = styled.div`
  display: flex;
  // width: 100%;
  justify-content: space-between;
  align-items: center;
  padding: 1rem 0;
  max-width: 20rem;
  gap:1rem;
`;

const ModalHeaderContainer = styled.div`
  text-align: right;
  width: 100%;
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: end;
`;

const DidNotReceive = styled.div`
  color: white;
  font-size: 1rem;
  font-weight: 300;
`;

const ResendText = styled.div`
  color: aqua;
  font-size: 1rem;
  font-weight: 300;
`;

const EnterOTPText = styled.div`
  color: #9b9b9b;
  font-size: 1rem;
  font-weight: 300;
`;

const ModalHeader = styled.div`
  color: white;
  font-size: 1.25rem;
  font-weight: 500;
`;

const SpinWheelModalCow = styled.img`
  width: 6rem;
`;

export default OTPModal;
